import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"

export const badgeApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_API_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState
      const authToken = state.auth.masquerade_access_token || state.auth.api_access_token
      const tokenType = state.auth.token_type
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      if (authToken) {
        headers.set("authorization", `${tokenType} ${authToken}`)
      }
      return headers
    },
  }),

  reducerPath: "badgeApi",
  tagTypes: ["AwardableBadges", "UserBadges", "AwardBadge"],
  endpoints: (builder) => ({
    getAwardableBadges: builder.mutation<API.Response.AllBadgesResponse, void>({
      query: (payload) => ({
        url: `/badges/awardable`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["AwardableBadges"],
    }),
    getUserBadges: builder.mutation<API.Response.UserBadgesResponse, API.Payload.UserBadgesPayload>({
      query: (payload) => ({
        url: `/profile/badges/user`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["UserBadges"],
    }),
  }),
})

export const { useGetAwardableBadgesMutation, useGetUserBadgesMutation } = badgeApi
